export const defaultThClass = 'align-middle text-capitalize font-medium text-[#333333] !text-[14px]'
export const defaultTdClass = 'align-middle text-capitalize text-[#333333] !text-[14px]'

export const columnsDetailNonKomship = [
  {
    key: 'order_no',
    label: 'No',
    tdClass: 'align-middle',
  },
  {
    key: 'awb',
    label: 'Nomor Resi',
    thClass: 'min-w-[180px]',
    tdClass: 'align-middle',
  },
  {
    key: 'products',
    label: 'Produk',
    thClass: 'min-w-[200px]',
    tdClass: 'align-middle',
  },
  {
    key: 'variant',
    label: 'Variasi',
    thClass: 'min-w-[200px]',
    tdClass: 'align-middle',
  },
  {
    key: 'total_item',
    label: 'Jumlah',
    tdClass: 'align-middle',
  },
  {
    key: 'packings',
    label: 'Bahan Packing',
    thClass: 'min-w-[280px]',
    tdClass: 'align-middle',
  },
  {
    key: 'status',
    label: 'Status',
    thClass: 'min-w-[160px]',
    tdClass: 'align-middle',
  },
  {
    key: 'fulfillment_fee',
    label: 'Biaya Fulfillment',
    thClass: 'min-w-[160px]',
    tdClass: 'align-middle',
  },
]

export const modalMessagesMapping = {
  'Belum Dipacking': [
    {
      title: 'Konfirmasi Packing Berhasil',
      description: 'Yuk! Segera packing order yang sudah kamu konfirmasi.',
      type: 'success',
      redirectTo: 'confirmed',
    },
    {
      title: 'Konfirmasi Packing Sebagian Order',
      description: 'Sebagian order dikonfirmasi untuk dipacking. Order yang tidak dikonfirmasi statusnya otomatis batal.',
      type: 'confirm',
      redirectTo: 'confirmed',
    },
  ],
  Dipacking: [
    {
      title: 'Order Terkirim',
      description: 'Order yang kamu konfirmasi, siap untuk dipickup oleh pihak ekspedisi.',
      type: 'success',
      redirectTo: 'shipped',
    },
    {
      title: 'Sebagian Order Terkirim',
      description: 'Sebagian order telah dipickup oleh ekspedisi. Order yang belum dikonfirmasi, statusnya tetap dipacking',
      type: 'confirm',
      redirectTo: 'shipped',
    },
  ],
  Dikirim: [
    {
      title: 'Order Terkirim',
      description: 'Order yang kamu konfirmasi, siap untuk dipickup oleh pihak ekspedisi.',
      type: 'success',
      redirectTo: undefined,
    },
    {
      title: 'Sebagian Order Terkirim',
      description: 'Sebagian order telah dipickup oleh ekspedisi. Order yang belum dikonfirmasi, statusnya tetap menunggu dipickup.',
      type: 'confirm',
      redirectTo: undefined,
    },
  ],
}

export const confirmTypeMapping = {
  'Belum Dipacking': 'confirm',
  Dipacking: 'ship',
  'Menunggu Pickup': 'ship',
  Dikirim: 'reship',
}
